// src/graphql/queries/savedSearchQueries.js

export const getSavedSearchReportLogs = () => `query GetSavedSearchReportLogs(
    $companyId: String
    $userId: String
    $limit: Int
    $offset: Int
) {
    adminSavedSearchReportLogs(
        companyId: $companyId
        userId: $userId
        limit: $limit
        offset: $offset
    ) {
        items {
            id
            userId
            companyId
            savedSearchId
            savedSearchName
            emailMode
            recipientEmail
            tendersIncluded
            searchesIncluded
            jobId
            sentAt
        }
        totalCount
    }
}`;
